import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import apiURL from '../../apiURL';

export const ContestHistory = ({ contestId, events }: {
    contestId: string;
    events: any[];
}) => {
    const [selected, setSelected] = useState('');
    const [entries, setEntries] = useState<any[]>([]);
    const [error, setError] = useState('');

    const open = async (eventId: string) => {
        setSelected(eventId);
        setEntries([]);
        setError('');
        try {
            const token = localStorage.getItem('auth') || '';
            const r = await fetch(
                `${apiURL}/contest-admin/${contestId}/entries/${eventId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (!r.ok) throw new Error();
            const data = await r.json();
            setEntries(Array.isArray(data) ? data : []);
        } catch {
            setError('Impossible de charger cet historique.');
        }
    };

    return (
        <section>
            <Typography variant="h6">Historique des événements</Typography>
            {events.length === 0 && <Typography>Aucun ancien événement.</Typography>}
            {events.map(e => (
                <div key={e.id} style={{ marginTop: 12 }}>
                    <Button onClick={() => open(e.id)} variant="outlined">
                        {e.name} — Voir les participants
                    </Button>
                </div>
            ))}
            {selected && (
                <div style={{ overflowX: 'auto', marginTop: 20 }}>
                    <Typography>Participants : {entries.length}</Typography>
                    <table style={{ width: '100%' }}>
                        <thead><tr><th>Ticket</th><th>Participant</th><th>Statut</th><th>Lot gagné</th><th>SMS</th></tr></thead>
                        <tbody>
                            {entries.map(e => (
                                <tr key={e.id}>
                                    <td>#{e.number}</td>
                                    <td>{e.firstname}</td>
                                    <td>{e.is_winner ? 'Gagnant' : 'Participant'}</td>
                                    <td>{e.won_prize?.name || '—'}</td>
                                    <td>{e.sms_status || '—'}{Array.isArray(e.sms_history) && e.sms_history.length > 0 && <details><summary>Historique SMS ({e.sms_history.length})</summary>{e.sms_history.map((h: any, i: number) => <div key={i}>{h.date ? new Date(h.date).toLocaleString("fr-FR") : "Date inconnue"} — {h.status} — {h.prize_name || e.won_prize?.name || "—"}{h.error ? ` — Erreur : ${h.error}` : ""}</div>)}</details>}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {error && <Typography color="error">{error}</Typography>}
        </section>
    );
};
